import AppAction from './action';
import * as actions from './action-types';
import {UserDetails} from '../../api/mirana-api';
import {mirana} from '@wize/mirana-proto/mirana-proto';

export function setIsAuthenticated(value: boolean): AppAction {
    return {type: actions.SET_IS_AUTHENTICATED, payload: {value},};
}

export function setIsLoading(value: boolean): AppAction {
    return {type: actions.SET_IS_LOADING, payload: {value},};
}

export function setUserDetails(userDetails: UserDetails): AppAction {
    return {type: actions.SET_USER_DETAILS, payload: {userDetails},};
}

export function setCarteraDetalle(carteraDetalle: mirana.CarteraDetalle, fuerzaVentaId: string): AppAction {
    return {type: actions.SET_CARTERA_DETALLE, payload: {fuerzaVentaId, carteraDetalle},};
}


// WEBPACK FOOTER //
// ./src/reduxstore/actions/action-creators.ts